import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import core from "./fr.core.json";

// Poids de départ : seuls les textes de la connexion et du cadre de l'application (fr.core.json) partent
// avec le premier fichier. Tous les autres (fr.json) arrivent à part, pendant que l'écran de connexion s'affiche.
void i18n.use(initReactI18next).init({
  resources: { fr: { translation: core } },
  lng: "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
  react: { bindI18nStore: "added" },
});

/** Tenue quand tous les textes sont là. Chaque écran chargé à la demande l'attend (voir App.tsx). */
export const allTexts: Promise<void> = import("./fr.json").then((m) => {
  i18n.addResourceBundle("fr", "translation", m.default, true, false);
});

export default i18n;
